// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
import myw from 'myWorld/base/core';
import 'myWorld/base/googleMapsLibrary';

/* globals google:false */

myw.GoogleOverlay = L.Layer.extend({
    includes: myw.Events, //ENH: not necessary anymore?

    /**
     * A layer rendered using a Google library. Only available with Google basemaps.
     * @param  {GoogleDatasource}   datasource
     * @param  {string}                 constructorName   Name of contructor function on 'google.maps' namespace
     * @constructs
     * @extends {L.ILayer}
     */
    initialize(datasource, constructorName, args, options) {
        L.setOptions(this, options);

        this.isVisible = false;
        this.datasource = datasource;
        this.constructorName = constructorName;
        this.args = args;
    },

    /**
     * Called when the gets added to a map.
     * Instantiates the google layer and adds it to the current google basemap.
     * @param  {MapControl} map
     */
    onAdd(map) {
        this.isVisible = true;

        //ensure the library is loaded before instantiating the layer
        this.datasource.initialized.then(() => {
            if (!this.googleLayer) {
                let Constructor = google.maps[this.constructorName];
                const args = [undefined].concat(args); //first arg is this/context which in the case of a constructor can be undefined
                Constructor = Function.prototype.bind.apply(Constructor, args);
                this.googleLayer = new Constructor();
            }

            this.isVisible = !!this.googleLayer; //as in is checked/selected

            this.datasource.system.recordDataAccess(
                this.datasource.database.applicationName,
                `layer.${this.constructorName}`
            );

            this.handleBasemapChange({ layer: map.getCurrentBaseMap() });
        });

        //since the basemap may not be a Google map when the layer is being added, we listen
        //for basemap changes and set it then
        map.on('baselayerchange', this.handleBasemapChange, this);
    },

    /**
     * Called when the layer is removed from the map
     * @param  {MapControl} map
     */
    onRemove(map) {
        if (this.isVisible) {
            this.googleLayer.setMap(null);
        }
        this.isVisible = false;

        map.off('baselayerchange', this.handleBasemapChange, this);
    },

    /**
     * Called when the basemap changes
     * If the new basemap is a google one, associate with it
     */
    handleBasemapChange(e) {
        const basemap = e.layer.leafletLayer;
        const isGoogleBasemap = basemap.datasource == this.datasource;
        const googleLayer = this.googleLayer;
        const isValid = googleLayer && isGoogleBasemap;

        this.fire(isValid ? 'valid' : 'invalid');

        if (this.isVisible && isGoogleBasemap) {
            e.layer.onAddPromise.then(() => {
                basemap.addGoogleLayer(googleLayer);
            });
        }
    }
});

export default myw.GoogleOverlay;
